import { createFileRoute } from "@tanstack/react-router";
import { AIIssueDetailPage } from "@corpuscomplete/web/modules/admin/ai-issue/pages/ai-issue-detail";

export const Route = createFileRoute("/_admin/admin/ai-issues/$id")({
  component: AIIssueDetailPage,
});
